import { useState, useEffect } from "react";

interface UseHeaderScrollOptions {
  threshold?: number; // Quantidade mínima de scroll para ativar o comportamento
  enableOnMobile?: boolean; // Se deve funcionar em mobile também
}

export const useHeaderScroll = (options: UseHeaderScrollOptions = {}) => {
  const { threshold = 50, enableOnMobile = false } = options;
  const [isHeaderVisible, setIsHeaderVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      // Se está no mobile e não deve funcionar no mobile, sempre mostra o header
      if (!enableOnMobile && window.innerWidth < 768) {
        setIsHeaderVisible(true);
        return;
      }

      // Se está no topo (posição 0), sempre mostra o header
      if (currentScrollY === 0) {
        setIsHeaderVisible(true);
      }
      // Se passou do threshold e está rolando para baixo, esconde o header
      else if (currentScrollY > threshold && currentScrollY > lastScrollY) {
        setIsHeaderVisible(false);
      }
      // Se está rolando para cima, mostra o header
      else if (currentScrollY < lastScrollY) {
        setIsHeaderVisible(true);
      }

      setLastScrollY(currentScrollY);
    };

    // Debounce para melhor performance
    let timeoutId: NodeJS.Timeout;
    const debouncedHandleScroll = () => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(handleScroll, 10);
    };

    window.addEventListener("scroll", debouncedHandleScroll);

    // Cleanup
    return () => {
      window.removeEventListener("scroll", debouncedHandleScroll);
      clearTimeout(timeoutId);
    };
  }, [lastScrollY, threshold, enableOnMobile]);

  return isHeaderVisible;
};
